export const RouteNames = {
    HOME: '/',
    LOGIN: '/login',
    DOCUMENT_UPLOAD: '/document-upload',
    PROJECT_EDIT: '/projects/:projectID',
    USERS: '/users',
    CREATE_ACT: '/act',
    ACT: '/act/:actId',
    NORMATIVE_DOCUMENTS: '/normative-documents',
    NORMATIVE_DOCUMENT_EDIT: '/normative-documents/:id',
    DEVICES: '/devices',
    PROJECTS: '/projects',
    PROFILE: '/profile',
    LIBRARY: '/library',
    NOT_FOUND: '/404',
    CHART_PAGE: '/kpi',
    CHART_DETAIL: '/kpi/:chartId',
    CHART_DEEP_ANALITICS: '/kpi/:chartId/:name',
    PODR_PAGE: '/contractors',
    DATA_LENS: '/dataLens',
    TESTS: '/tests',
}
